import { render, staticRenderFns } from "./CardEditDialog.vue?vue&type=template&id=f9407a22&scoped=true"
import script from "./CardEditDialog.vue?vue&type=script&lang=js"
export * from "./CardEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9407a22",
  null
  
)

export default component.exports